import React, { useEffect, useState } from "react";
import Header from "./Header";
import SocialSection from "./SocialSection";
import OverviewSection from "./OverviewSection";
import data from "../data";

function App() {
  const [theme, setTheme] = useState("dark-theme");
  const [details, setDetails] = useState(data);
  console.log(details);

  const toggleTheme = () => {
    if (theme === "light-theme") {
      setTheme("dark-theme");
    } else {
      setTheme("light-theme");
    }
    console.log("clicked");
  };

  useEffect(() => {
    document.documentElement.className = theme;
  }, [theme]);

  return (
    <main>
      <Header toggleTheme={toggleTheme} theme={theme} />
      <SocialSection details={details} />
      <OverviewSection details={details} />
    </main>
  );
}

export default App;
